import Vue from 'vue';
import VueI18n from 'vue-i18n';
import tw from './zh-TW.json'; // 存放繁中翻譯
import cn from './zh-CN.json';// 存放簡中翻譯
import en from './en.json';// 存放英文翻譯

Vue.use(VueI18n);
let fallbackLocale = '';
switch (navigator.language.toLowerCase()) {
  case 'zh-tw':
    fallbackLocale = 'tw';
    break;
  case 'zh-cn':
    fallbackLocale = 'cn';
    break;
  default:
    fallbackLocale = 'en';
    break;
}
export default new VueI18n({
  locale: fallbackLocale, // 初始語系
  fallbackLocale,
  messages: { tw, cn, en }
});
